// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pSVqy","subTitle":"styles_subTitle__Zb3cD","vector":"styles_vector__HUCaF"};